import React, {useContext} from 'react';
import { Route, Redirect } from 'react-router-dom';
import {UserContext} from './context/userContext'

const PrivateRoute = ({component: Component, ...rest}) => {

  const {isSignedIn, pendingAuth} = useContext(UserContext)


    return (
        <Route {...rest} render={props => (
            (isSignedIn && !pendingAuth) ?
                  <Component {...props} />
                 :
                  <Redirect to="/login" />
        )} />
    )
}

export default PrivateRoute
